// client/src/pages/WeTakeoverPage.jsx
import React, { useRef } from 'react';
import HeroSection from '../components/wetakeover/HeroSection';
import TrustedBy from '../components/wetakeover/TrustedBy';
import VideoSection from '../components/wetakeover/VideoSection';
import CampaignWizard from '../components/wetakeover/CampaignWizard';

const WeTakeoverPage = () => {
  const wizardRef = useRef(null);

  const scrollToWizard = () => {
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    wizardRef.current?.scrollIntoView({
      behavior: reducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });
  };

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden overflow-y-auto py-12 px-4 md:px-6">
      {/* Hero Section */}
      <HeroSection onBuildCampaign={scrollToWizard} />

      {/* Trusted By Section - Animated Logo Marquee */}
      <TrustedBy />

      {/* Video Section */}
      <VideoSection />

      {/* Campaign Wizard Section */}
      <div ref={wizardRef}>
        <CampaignWizard />
      </div>
    </div>
  );
};

export default WeTakeoverPage;
